import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable()

export class NotificationService {
	NOTIFICATION_URI: string = environment.apiUrl + '/notification';

	constructor(private httpClient: HttpClient) {}

	public getNotificationByUser = (userId) => {
		console.log(this.NOTIFICATION_URI + `/${userId}`)
		return this.httpClient.get(this.NOTIFICATION_URI + `/${userId}`);
	}
	public update = (body) => {
		
		console.log(this.httpClient);
		return this.httpClient.put(this.NOTIFICATION_URI, body);
		
	}


}



// WEBPACK FOOTER //
// ./src/app/services/notification.service.ts